import { Theme } from "@ctypes";
import { darkTheme, palette } from "@layout";
import { entryColors } from "./tokens";

/**
 * Theme applied inside the entry shell. Derived from the app dark theme so
 * every shared themed component (TextInput, CodeInput, Typography, Loader,
 * disclaimers, AddressForm…) renders legibly over the video background,
 * with glass surfaces and the mockups' green/terracotta CTAs.
 */
export const entryTheme: Theme = {
  ...darkTheme,
  background: "transparent",
  text: {
    ...darkTheme.text,
    secondary: entryColors.textSecondary,
    highlight: entryColors.highlight,
  },
  input: {
    ...darkTheme.input,
    background: entryColors.glassFill,
    text: palette.white[100],
    placeholder: palette.white[40],
    error: entryColors.error,
  },
  button: {
    background: {
      ...darkTheme.button.background,
      primary: entryColors.green,
      secondary: entryColors.glassFillStrong,
      disabled: "rgba(180, 180, 190, 0.35)",
    },
    text: {
      ...darkTheme.button.text,
      primary: palette.white[100],
      secondary: palette.white[100],
    },
  },
  loader: {
    ...darkTheme.loader,
    inverse: palette.white[100],
  },
};
